export default __webpack_public_path__ + "4663f83a3f5e0601b43b82bbf6e2f201.svg";